"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeView = changeView;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _action_types = require("../../constants/action_types");
var _events = require("../../types/events");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function changeView(view, data) {
  return (dispatch, getState, context) => {
    const {
      view: prevView
    } = getState();
    let currentData = data;

    /**
     * @description В данном кейсе нам нужно достичь поведения, при котором,
     * если тип заголовка не поменялся из параметра data, то мы его сохраняем. Это нужно в поведении,
     * когда мы перешли на следующий тип отображения, а потом перешли на шаг назад,
     * у нас сохранялся альтернативный заголовок
     */
    if (prevView.data?.headingType) {
      currentData = _objectSpread({
        headingType: prevView.data.headingType
      }, currentData);
    }
    dispatch({
      type: _action_types.AUTHENTICATION_CHANGE_VIEW_TYPE,
      view,
      data: currentData
    });
    context.emitter.emit(_events.EEventType.ViewChanged, {
      prevView: prevView.active,
      prevData: prevView.data,
      view,
      data: currentData
    });
  };
}